export default __webpack_public_path__ + "static/media/add-to-list-icon.10497fa3.svg";